import { useEffect } from "react";
import { Loader } from "@servicetitan/web-components";
import { AnvilProvider, Flex, Spinner, Text } from "@servicetitan/anvil2";
import { setFullStoryProperties } from "./fullstory-util";
import { getMfeTag } from "./get-mfe-tag";

const LoadingFallback = (
  <Flex
    alignItems="center"
    direction="column"
    justifyContent="center"
    gap="2"
    style={{ width: "100%" }}
  >
    <Spinner style={{ width: "50px", margin: "25px" }} />
    <Text>Loading...</Text>
  </Flex>
);

function App() {
  const params = Object.fromEntries(
    new URLSearchParams(window.location.search),
  );

  const tag = getMfeTag();

  useEffect(() => {
    const props = Object.fromEntries(
      new URLSearchParams(window.location.search),
    );
    if (Object.keys(props).length > 0) {
      setFullStoryProperties(props);
    }
  }, []);

  return (
    <AnvilProvider>
      <div>
        <Loader
          src={`https://unpkg.servicetitan.com/@servicetitan/prequals-landing@${tag}`}
          data={params}
          loadingFallback={LoadingFallback}
        />
      </div>
    </AnvilProvider>
  );
}

export default App;
